<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles contractDetails">
            <van-nav-bar title="合同进度" left-text="进度" left-arrow @click-left="onClickLeft"></van-nav-bar>
            <section class="showFontBtn">
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>基本信息
                        </div>
                        <van-cell
                            :value="Monomer.monomer_name"
                            title="单体名称"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            :value="Monomer.monomer_number"
                            title="单体编号"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="(Monomer.projected_capacity || 0)+'m³'"
                            title="预计方量"
                            :icon="require('@/assets/images/icons/icon_30.png')"
                        ></van-cell>
                        <van-cell
                            :value="(Monomer.used_capacity || 0)+'m³'"
                            title="已用方量"
                            :icon="require('@/assets/images/icons/icon_30.png')"
                        ></van-cell>
                        <van-cell
                            :value="Monomer.floors"
                            title="总楼层"
                            :icon="require('@/assets/images/icons/icon_gy_8.png')"
                        ></van-cell>
                        <van-cell
                            :value="Monomer.ground_floors"
                            title="地上楼层"
                            :icon="require('@/assets/images/icons/icon_gy_8.png')"
                        ></van-cell>
                        <van-cell
                            :value="Monomer.underground_floors"
                            title="地下楼层"
                            :icon="require('@/assets/images/icons/icon_gy_8.png')"
                        ></van-cell>
                        <van-cell
                            :value="Monomer.current_floors"
                            title="施工楼层"
                            :icon="require('@/assets/images/icons/icon_gy_8.png')"
                        ></van-cell>
                    </van-collapse-item>
                    <van-cell
                        :value="Monomer.current_progress_name"
                        title="施工阶段"
                        :icon="require('@/assets/images/icons/my_9.png')"
                        is-link
                        @click="openClick"
                    ></van-cell>
                    <van-collapse-item name="2">
                        <div slot="title" class="title">
                            <i class="iconfont iconshipin"></i>形象进度
                        </div>
                        <div class="img-wrapper">
                            <van-uploader v-model="fileList" multiple :before-read="uploadFileBefore" :after-read="uploadFileMethod" @delete="deleteFile">
                                <div class="upload-wrapper">
                                    <i class="iconfont iconicon-test"></i>
                                </div>
                            </van-uploader>
                        </div>
                    </van-collapse-item>
                </van-collapse>
                <van-popup round v-model="isPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        title=""
                        :default-index="sgIndexFun()"
                        :columns="columns"
                        @cancel="onCancel"
                        @confirm="onConfirm"
                    ></van-picker>
                </van-popup>
            </section>
            <footer class="commonFormBtns">
                <van-button type="info" @click="onSave">
                    保存
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
import { Toast } from 'vant';
import { mixin_fileUpload } from '@/assets/mixin/mixin_fileUpload';
export default {
    // 合同进度详情
    name: 'contract-details',
    components: {},
    props: {},
    mixins: [mixin_fileUpload],
    data() {
        return {
            activeNames: ['1', '2'],
            Monomer: {}, // 单体详情信息
            images_data: [], // 保存施工阶段的所有图片的集合
            fileList: [], // 上传图片显示的list
            emid: this.$route.params.emid, // 上一个页面带过来的单体id
            detail: this.$route.params.obj, // 上一个页面带过来的合同信息
            active: this.$route.params.active, // 上一个页面带过来的tabnav 选中值 0 工程进度 1 单体进度
            isPicker: false, // 施工阶段选择列表显示隐藏
            columns: [], // 施工阶段下拉选择数据
            sgList: [], // 施工阶段字典查询数据
            fileDataId: this.$route.params.emid,
        };
    },
    computed: {},
    watch: {},
    created() {
        // 获取单体详情
        this.getEngineeringMonomer();
        // 获取施工阶段字段list
        this.constructionSelectList();

    },
    mounted() {},
    destroyed() {},
    methods: {
        // 初始化默认选择对应的施工阶段
        sgIndexFun() {
            let Index = 0;
            this.sgList.map((item, index) => {
                if (item.code === this.Monomer.current_progress) {
                    Index = index;
                }
            });
            return Index;
        },
        // 打开picker控件
        openClick() {
            this.isPicker = true;
        },
        onConfirm(val, index) {
            // 确定施工阶段
            this.isPicker = false;
            this.Monomer.current_progress = this.sgList[index].code;
            this.Monomer.current_progress_name = val;
        },
        onCancel() {
            // 取消施工阶段
            this.isPicker = false;
        },
        // 获取施工阶段字段list
        constructionSelectList() {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=108&type=1')
                .then(res => {
                    this.sgList = res;
                    this.columns = [];
                    res.forEach(item => {
                        this.columns.push(item.name);
                    });
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取单体基本信息
        getEngineeringMonomer() {
            this.$axios
                .get('/interfaceApi/sale/engineering_progress/get_engineering_monomer/' + this.emid)
                .then(res => {
                    this.Monomer = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 上传的回调，uploadFirm 成功后 mixin 会调用此方法传入文件信息
        callBackFun(res) {
            if (res && res.FileID) {
                this.images_data.push(res.FileID);
            }
        },

        // 删除文件（覆盖 mixin，额外清理 images_data）
        deleteFile(item) {
            // 从 images_data 中移除
            const idx = this.images_data.indexOf(item.FileID);
            if (idx > -1) {
                this.images_data.splice(idx, 1);
            }
            // 调用 mixin 原有的删除逻辑
            const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${item.AFI_Code}`;
            this.$axios.delete(url, {})
                .then(() => {
                    this.deleteFile_process(item.FileID);
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },

        // 保存施工阶段
        onSave() {
            Toast.loading({
                message: '请求中...',
                forbidClick: false,
                loadingType: 'spinner',
            });
            this.$axios
                .post('/interfaceApi/sale/engineering_progress/add_engineering_Monomer', {
                    monomer_id: this.emid,
                    current_progress: this.Monomer.current_progress,
                    current_progress_name: this.Monomer.current_progress_name,
                    images_data: this.images_data.join(','),
                })
                .then(() => {
                    Toast.success({
                        message: '保存成功',
                        duration: 500,
                    });
                    setTimeout(() => {
                        this.$router.isBack = 1;
                        this.$router.replace({ name: 'schedule', params: { obj: this.detail, active: this.active } });
                        this.$router.go(-1);
                    }, 1000);
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'schedule', params: { obj: this.detail, active: this.active } });
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'schedule', params: { obj: this.detail, active: this.active } });
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus">
.contractDetails
    height 100%
    section
        .van-cell
            display flex
            .van-cell__title
                flex 1
            .van-cell__value
                flex 2
        .img-wrapper
            padding 15rpx
            .van-uploader__wrapper
                .van-uploader__preview
                    width 75rpx
                    height 75rpx
                    border 1px solid rgba(215,215,215,1)
                    border-radius 4rpx
                    margin 0 10px 10px 0
                    img
                        width 73rpx
                        height 73rpx
            .upload-wrapper
                width 75rpx
                height 75rpx
                border 1px solid rgba(215,215,215,1)
                border-radius 4rpx
                line-height 75rpx
                text-align center
    .van-icon
        .van-icon__image
            width 16rpx
            height 16rpx
            margin-top 3rpx
            margin-right 5rpx
    .van-collapse
        &:after
            display none
    .van-cell__title
        width 100rpx
        font-size 16rpx
        line-height 24rpx
        color #061F3E
        .iconfont
            font-size 18rpx
            margin-right 5rpx
    .van-collapse-item__content
        .van-cell__title
            font-size 16rpx
    .title
        font-size 17rpx
        color #3495FB
    .van-collapse-item__content
        padding 0
    .van-field__control,
    .van-cell__value
        color #979EA7
        &::placeholder
            color #D7D7D7 !important
</style>
